var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-dropdown',{staticClass:"actions",attrs:{"aria-role":"list","position":_vm.position}},[_c('button',{staticClass:"button action",attrs:{"slot":"trigger"},slot:"trigger"},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t('button.action')))]),_vm._v(" "),_c('b-icon',{attrs:{"icon":'sort-down'}})],1),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }